import { render, staticRenderFns } from "./PDFGenerator.vue?vue&type=template&id=5ef8bb18"
import script from "./PDFGenerator.vue?vue&type=script&lang=js"
export * from "./PDFGenerator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports